import createLogger from 'vuex/dist/logger'
// import jsdataPlugin from 'vuex-plugin-jsdata'
//
// const plugins = [
//   jsdataPlugin(DSStore, {
//     initialState,
//   }),
// ]
import auth from '@/services/auth.js'
const authPlugin = store => {
  auth.on('auth:success', ({ contexte_usager: { id, context_id } }) =>
    store.commit('USER_REGISTER', { id, context_id }))
  auth.on('auth:fail', () => store.commit('USER_RESET'))
}
const plugins = [authPlugin]

export default process.env.NODE_ENV !== 'production'
  ? [createLogger(), ...plugins]
  : plugins



// WEBPACK FOOTER //
// ./src/vuex/plugins.js